import { useContext } from 'react'
import '../../style/components/search.css'
import { useTranslation } from 'react-i18next';
import { context } from '../../context/context';
import ByBarcode from "../../docs/light/password.png";
import ByProduct from "../../docs/light/box.png";
import { switchh } from '../../context/switch';
import { references } from '../../context/ref';

export default function Search () {
    const { setSearch, search, setCatChoose } = useContext(context);
    const { SearchInput } = useContext(references);
    const { setLoadingDebounce } = useContext(switchh); 
    const { t } = useTranslation();

    return (
        <div className="search">
            <input ref={SearchInput} type='text' onChange={(e)=> {
                // run debounce function to delay the search until the user stops typing for a short period
                setLoadingDebounce(true);
                setSearch((prev) => ({
                    ...prev,
                    value: e.target.value
                }));
                setCatChoose("");
            }} value={search.value} placeholder={
                    t("placeholder:pos.searchByProduct", 
                    { typeOfSearch: search.bySearial ? t("placeholder:pos.id") : t("placeholder:pos.productName") })
                } />
            <button onClick={() => {
                setSearch((prev) => ({
                    ...prev,
                    bySearial: !search.bySearial
                }));
            }}>
                <img width={'20'} src={!search.bySearial ? ByBarcode : ByProduct} alt={!search.bySearial ? "By Barcode" : "By Product"} />
            </button>
        </div>
    )
}